export function compareDates(a: Date | undefined, b: Date | undefined) {
  if (!a && !b) {
    return 0;
  } else if (!a || !b) {
    return !a ? -1 : 1;
  } else if (a < b) {
    return -1;
  } else if (a > b) {
    return 1;
  } else {
    return 0;
  }
}
